<template>
  <div></div>
</template>
<script>
import wx from "weixin-js-sdk";
import { wechat, weiXingSDK } from "@/api/user";

/**
 * 微信网页授权
 */
const wxAppId = process.env.VUE_APP_WX_APPID;
const WXAuthorizeUrl = process.env.VUE_APP_WX_AUTHORIZEURL;
const redirectUrl = encodeURIComponent(WXAuthorizeUrl);
export default {
  name: "WxAuth",
  created() {
    if (this.$route.query.code) {
      this.login(this.$route.query.code);
    } else {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&state=${this.$route.query.redirect}#wechat_redirect`;
    }
  },
  methods: {
    // 登录
    login(code) {
      wechat(code).then((res) => {
        // console.log("登录: ", res);
        if (res.code === 0) {
          localStorage.setItem("myToken", res.result.token);
          weiXingSDK(encodeURIComponent(location.href)).then((res) => {
            wx.config({
              debug: false,
              appId: res.appId,
              timestamp: res.timestamp,
              nonceStr: res.nonceStr,
              signature: res.signature,
              jsApiList: ["scanQRCode"],
            });
            this.$router.replace(this.$route.query.state);
          });
        } else if (res.code === 40002) {
          this.$router.push({
            name: "login",
            params: {
              openid: res.result.openid,
              redirect: this.$route.query.state,
            },
          });
        } else if (res.code === 10002) {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&state=${this.$route.query.redirect}#wechat_redirect`;
        }
      });
    },
  },
};
</script>
